import * as Yup from "yup";

export const loginFormSchema = Yup.object({
  username: Yup.string().email().trim().required("Please enter your email"),
  password: Yup.string()
    .trim()
    .required("Please enter your password")
    .min(6, "Password must be at least 6 characters long"),
});
